// pages/Connector/Channels.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tabs, Tab } from '@mui/material';
import backendURL from "../../config";

export default function Channels() {
    useEffect(() => {
        document.title = 'Channels | KlonIT Web Application';
    }, []);



    return (
        <div>
            <main className="content">
                <div className="container-fluid p-0">
                    <div className="mb-3">
                        <h1 className="h3 d-inline align-middle"><strong>Channels </strong> </h1>
                    </div>
                    <div className="row">
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="card">
                                <div class="card-header text-center">
                                    <i class="fa fa-whatsapp fa-5x" aria-hidden="true"></i>

                                </div>
                                <div class="card-body text-center">
                                    <h3 class="card-title mb-0">Whatsapp Bot</h3>
                                    <br />
                                    <p class="card-text">Automate conversations with intelligent chat responses, handling customer queries efficiently.</p>
                                    <a href="whatsapp-connector" class="btn btn-primary">Configure</a>
                                </div>
                            </div>
                        </div>
                        
                    </div>


                </div>
            </main>
        </div>
    );
}
